<template>
  <section class="sharer-popup-wrapper">
    <van-popup
      v-model="showPopup"
      class="fission-sharer-popup"
      get-container=".sharer-popup-wrapper"
      @opened="opened"
      @closed="closed"
      :style="{ width: '100%' }"
    >
      <div class="popup-logo">
        <img
          class="icon"
          v-lazy="
            require(`@/assets/images/activities/fission/pubgm/toplupe-pubgm.png`)
          "
          alt="logo"
        />
      </div>
      <div class="popup-body">
        <img
          class="personage"
          v-lazy="
            require(`@/assets/images/activities/fission/pubgm/pubgm-personage.png`)
          "
          alt="logo"
        />
        <div class="popup-content">
          <div class="title">
            <p class="text">{{ getTitle }}</p>
          </div>
          <div class="coupon-bar">
            <div class="coupon-money">
              <span class="up-to">До</span>
              {{ awardInfos.formatAwards }}
            </div>
            <img class="coupon-icon" v-lazy="awardInfos.icon" alt="logo" />
          </div>
        </div>
      </div>
      <div class="handle-btns">
        <button class="google login" @click="login('google')"></button>
        <!-- <button class="facebook login" @click="login('facebook')"></button> -->
        <button class="vk login" @click="login('vk')"></button>
      </div>
    </van-popup>
  </section>
</template>
<script>
  // 分享者弹框
  import { mapState } from 'vuex'
  import { getMaxAwardInfos } from '../../helper'

  export default {
    data() {
      return {
        showPopup: true,
        awardInfos: {},
      }
    },
    computed: {
      ...mapState(['fissionInfos']),
      getTitle() {
        const {
          extraInfo: { noLoginShareTitle },
        } = this.fissionInfos

        return noLoginShareTitle || ''
      },
    },
    mounted() {
      getMaxAwardInfos().then((res) => {
        const { awardType, couponType } = res || {}
        const infos = res
        switch (awardType) {
          case 3:
            infos.icon = require(`@/assets/images/activities/fission/icon/coupon-new.png`)
            if (couponType === 1) {
              infos.formatAwards = infos.currency + infos.awardCount + ' OFF'
            } else {
              infos.formatAwards = `${100 - infos.awardCount}% OFF`
            }
            break
          case 4:
            infos.icon = require(`@/assets/images/activities/fission/icon/uc-new.png`)
            infos.formatAwards = infos.awardCount
            break
          case 5:
            infos.icon = require(`@/assets/images/activities/fission/icon/kgold-new.png`)
            infos.formatAwards = infos.awardCount
            break
        }
        this.awardInfos = infos
      })
    },
    methods: {
      opened() {
        this.$emit('opened')
      },
      closed() {
        this.$emit('closed')
      },
      login(type) {
        this.$emit('toLogin', type)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .sharer-popup-wrapper {
    padding: 0 108px;
    box-sizing: border-box;
    .fission-sharer-popup {
      background-color: transparent;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-image: url('~@/assets/images/activities/fission/pubgm/popup-bg-bottom.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      padding-top: 30px;
      box-sizing: border-box;
    }
    .popup-logo {
      width: 100%;
      padding-right: 108px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 30px;
      .icon {
        height: 58px;
      }
    }
    .popup-body {
      width: 864px;
      height: 596px;
      border-radius: 36px;
      background-image: url('~@/assets/images/activities/fission/pubgm/pubgm-bg.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      padding: 40px;
      box-sizing: border-box;
      .personage {
        width: 416px;
        object-fit: cover;
        transform: translate(-30px, -126px);
        position: absolute;
        left: 0;
        top: 0;
      }
      .popup-content {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        align-items: flex-end;
        width: 100%;
        .title {
          width: 500px;
          height: 256px;
          margin-top: 26px;
          margin-bottom: 56px;
          display: flex;
          align-items: center;
          text-align: center;
          .text {
            width: 100%;
            max-height: 256px;
            font-weight: 700;
            font-size: 48px;
            line-height: 1;
            display: flex;
            align-items: center;
            text-align: center;
            color: #ffc52f;
            @include canWrap($lineCount: 4);
          }
        }
        .coupon-bar {
          width: 100%;
          height: 196px;
          background-image: url('~@/assets/images/activities/fission/pubgm/coupon-sharer-bg.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          font-weight: 700;
          font-size: 84px;
          line-height: 1;
          display: flex;
          align-items: center;
          color: #96460c;
          transform: rotate(0deg);
          padding: 48px 28px 48px 48px;
          box-sizing: border-box;
          justify-content: space-between;

          .coupon-money {
            flex: 1;
            text-align: center;
            position: relative;
            .up-to {
              position: absolute;
              left: 0;
              top: -50%;
              font-size: 20px;
              padding: 10px 20px 20px 48px;
              box-sizing: border-box;
            }
          }
          .coupon-icon {
            width: 170px;
            height: 170px;
            object-fit: cover;
            margin-left: 10px;
          }
        }
      }
    }
    .handle-btns {
      margin-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .login {
        width: 864px;
        height: 140px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        &.facebook {
          background-image: url('~@/assets/images/activities/fission/icon/facebook.png');
          margin-top: 36px;
        }
        &.google {
          background-image: url('~@/assets/images/activities/fission/icon/google.png');
        }
      }
    }
  }
</style>
